<template lang="pug">
div
  h1 Motivo de Perda

  .light-gray-text.light-text
    | Cadastre motivos de perda que serão atribuídos aos contatos marcados com o estágio 'Perdido'. Ex.: Falta de budget
    br
    | Os motivos de perda cadastrados aqui estarão disponíveis para todo o time de vendas.

  br
  br

  new-lost-reason(@created="createdLostReason")

  .table
    .table-body
      hr
      list-item(v-for="lost_reason in $store.getters.lostReasonsList",
                :lost_reason="lost_reason",
                :key="lost_reason.id",
                @updated="updatedLostReason",
                @destroy="openDestroyConfirmationModal")
  div(align="center")
    loading(:loading="$store.getters.lostReasonLoading")
    .light-gray-text.light-text(v-show="!$store.getters.lostReasonLoading") Sem mais resultados

  confirm-modal(
    id='confirm-destroy-lost-reason'
    title='Excluir motivo de perda',
    confirm_text='Sim, excluir'
    confirm_class='btn-danger',
    @confirm-modal-confirm='destroyLostReason'
  )
    br
    div.text-center
      div Confirma exclusão do motivo de perda abaixo?
      br
      strong.dark-red-color {{ selected_lost_reason.title }}
      br
      br
</template>

<script>
  import helpers from '../../helpers.coffee'

  const view_model = {
    components: {
      listItem: require('./list_item.vue'),
      newLostReason: require('./new.vue')
    },
    data() {
      return {
        title: '',
        editing: null,
        selected_lost_reason: {}
      }
    },

    methods: {
      loadLostReasons() {
        if(this.$store.getters.lostReasonsCount == 0){
          this.$store.dispatch('fetchLostReasons')
        }
      },

      toggleEditClass(id) {
        if (this.editing && (this.editing.id === id)) {
          return ''
        } else {
          return 'hidden'
        }
      },

      updatedLostReason(lost_reason) {
        const index = this.lost_reasons.findIndex(lost_reason.id)
        this.lost_reasons.replaceById(lost_reason)
      },

      createdLostReason(lost_reason) {
        this.lost_reasons.unshift(lost_reason)
      },

      openDestroyConfirmationModal(lost_reason) {
        this.selected_lost_reason = lost_reason
        EventsBus.$emit('confirm-modal-show', {id: 'confirm-destroy-lost-reason'})
      },

      destroyLostReason() {
        this.$store.dispatch('removeLostReason', {id: this.selected_lost_reason.id})
      }
    },

    beforeCreate() {
      if (Session.current_user.isSeller() || Session.current_user.isMonitoringManager()) {
        return this.$router.push('/configuracoes/perfil')
      }
    },

    created() {
      return this.loadLostReasons()
    }
  }

  exports.default = helpers.vue_include(view_model, helpers.form)
</script>


<style lang="sass" scoped>

  @import "../../assets/stylesheets/_variables.sass"

  input.form-control
    height: 38px

  .table-col:first-child
    padding-left: 20px

</style>



// WEBPACK FOOTER //
// index.vue?46026b35